import { React, models, kea, history, resources, selectores, componentToRx, Route, match, withRouter } from "app/main/std";

export interface Props {
    value?: boolean;
    onChange?: (value: boolean) => PromiseLike<void> | void;
    label?: string;
    descripcion: string;
}

/**
* Checkbox de un rol
*/
export class RolCheck extends React.PureComponent<Props> {

    render() {
        const { value, onChange, label, descripcion } = this.props;
        return (
            <div>
                <kea.Checkbox value={value} onChange={onChange} label={
                    <span>
                        <label>
                            {this.props.label}
                        </label>
                        {" "}
                        <span style={{ fontStyle: "italic", color: "blue" }}>
                            {descripcion}
                        </span>
                    </span>} />

            </div>);
    }
}


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/roles/edit/componentes/check.tsx